import { Box, Flex, Text } from '@chakra-ui/react';
import { ReactComponent as VenngageLogoIcon } from 'assets/icons/venngage_logo.svg';
import { memo } from 'react';

import { BotMessageProps } from '../Chat.types';

/**
 * Render the basic bot message in the ChatPanel
 * If it is the first index. margin is auto to push the message to the bottom
 *
 * @param data.messages[0] The text to be displayed
 */
export const BotMessage = memo(({ data, index }: BotMessageProps) => {
  const isFistMessage = index === 0;

  const ChatBotMessageTestId = 'chat-bot-message';

  return (
    <Flex mt={`${isFistMessage ? 'auto' : ''}`} gap='4' data-testid={ChatBotMessageTestId}>
      <Flex alignItems='flex-end'>
        <VenngageLogoIcon width='24px' height='24px' color='var(--vg-colors-brand-500)' />
      </Flex>
      <Box p='2' borderRadius='lg' bg='violet.50' flexGrow='1'>
        <Text>{data.messages[0]}</Text>
      </Box>
    </Flex>
  );
});

BotMessage.displayName = 'BotMessage';
